import * as isomorphicLocalStorage from 'lib/storage/isomorphicLocalStorage'

/**
 * Not prefixed with `loyalty-societe-rewards-` / `loyalty-tier-progress-snackbar-`, which are cleared
 * on logout — the modal must stay seen across logins.
 */
const STORAGE_PREFIX = 'statusMatchEnrolledModalSeen:'

export interface EnrolledModalEnrollment {
  enrollmentId: string
  expiresAt: string
}

/**
 * Re-enrolling reactivates the same enrollment row (same id) with a new expiry, so the expiry is part of the
 * key — a re-enrolled member sees the modal again, matching the enrolment email's dedupe.
 */
export function getEnrolledModalSeenId({ enrollmentId, expiresAt }: EnrolledModalEnrollment): string {
  return `${enrollmentId}:${expiresAt}`
}

function getStorageKey(enrollment: EnrolledModalEnrollment) {
  return `${STORAGE_PREFIX}${getEnrolledModalSeenId(enrollment)}`
}

export function hasSeenEnrolledModal(enrollment: EnrolledModalEnrollment): boolean {
  // Without persistent storage (SSR, privacy modes) "seen" can't survive a reload, so never show
  if (!isomorphicLocalStorage.isPersistent()) return true
  try {
    return !!isomorphicLocalStorage.get(getStorageKey(enrollment))
  } catch {
    // Storage can fail in privacy modes — treat as seen so the modal can't show on every page load
    return true
  }
}

export function recordEnrolledModalSeen(enrollment: EnrolledModalEnrollment): void {
  try {
    isomorphicLocalStorage.set(getStorageKey(enrollment), new Date().toISOString())
  } catch {
    // Storage can fail in privacy modes or when quota is exhausted.
  }
}
